/*
 * Registro del Service Worker.
 * - En producción (NODE_ENV=production) intentamos registrar /sw.js.
 * - En desarrollo desregistramos SW previos para no interferir con hot-reload.
 */

export function registerServiceWorker() {
  if (typeof window === "undefined") return;

  if ("serviceWorker" in navigator) {
    if (process.env.NODE_ENV !== "production") {
      // Dev: limpiar SW de caché previos (el push-sw.js sin fetch handler se conserva)
      navigator.serviceWorker.getRegistrations().then((regs) => {
        regs.forEach((r) => {
          if (!(r.active?.scriptURL || "").includes("push-sw.js")) r.unregister();
        });
      });
      return;
    }

    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/sw.js", { scope: "/" })
        .then((reg) => {
          // eslint-disable-next-line no-console
          console.log("[SW] registered scope:", reg.scope);
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.warn("[SW] registration failed", err);
        });
    });
  }
}
